module.exports = __webpack_public_path__ + "assets/img/afe240262f1c23649c57caa3d1232cc9.svg";